export default "/assets/images/basic-breather1.png?bb78154a8e0ff23b108a93e1feae78d7";